import { useState } from 'react'
import { PhoneIcon, XIcon, UserIcon } from '../icons'
import { avatarUrlById } from '../utils/avatar'
import type { CallState } from '../context/CallContext'

// Compact incoming-call indicator pinned to the bottom of the screen.
// Shown on every page (mounted in GlobalCallOverlay) so the callee
// notices the call even when they're not on the DM — the full-screen
// incoming overlay was easy to miss while navigating. Shows the
// caller's avatar + name and accept/reject buttons.
export function IncomingCallToast({ call }: { call: CallState }) {
  const incoming = call.incomingCall
  const [avatarFailed, setAvatarFailed] = useState(false)
  if (!incoming) return null

  const fromId = incoming.fromUserId || ''
  const avatarUrl = avatarUrlById(fromId)
  const name = incoming.callerName || 'Alguém'
  const kind = incoming.isVideo ? 'de vídeo' : 'de voz'

  return (
    <div className="incoming-call-toast" role="alert">
      <div className="incoming-call-toast-avatar">
        {avatarUrl && !avatarFailed ? (
          <img src={avatarUrl} alt="" onError={() => setAvatarFailed(true)} />
        ) : (
          <UserIcon size={22} />
        )}
      </div>
      <div className="incoming-call-toast-text">
        <span className="incoming-call-toast-name">{name}</span>
        <span className="incoming-call-toast-sub">Chamada {kind} recebida</span>
      </div>
      <button
        className="incoming-call-toast-btn reject"
        onClick={call.rejectCall}
        title="Recusar"
      >
        <XIcon size={18} />
      </button>
      <button
        className="incoming-call-toast-btn accept"
        onClick={call.acceptCall}
        title="Atender"
      >
        <PhoneIcon size={18} />
      </button>
    </div>
  )
}
